import { makeAutoObservable, runInAction } from "mobx";
import axios from "axios";

import MarketStore from "./MarketStore";
import AccountStore, {ISerializedAccountStore} from "./AccountStore";
import NotificationStore from "./NotificationStore";
import WalletStore from "./WalletStore";
import RequestQueue from "./RequestQueue";


interface IAssetInfo {
  assets: {
      id: string;
      data: {
          'lastPrice_usd-n': number;
          'lastPrice_usd': number;
          'lastPrice_busd': number;
          'lastPrice_usdt-ppt': number;
      }
  }[];
}

export interface ISerializedRootStore {
  accountStore?: ISerializedAccountStore;
}

export default class RootStore {
  public accountStore: AccountStore;
  public marketStore: MarketStore;
  public notificationStore: NotificationStore;
  public walletStore: WalletStore;
  public requestQueue: RequestQueue;

  usdnPrices: {[x: string]: number} = {
    WAVES: 0,
    HEB8Qaw9xrWpWs8tHsiATYGBWDBtP2S7kcPALrMu43AS: 0,
    C1iWsKGqLwjHUndiQ7iXpdmPum9PeCDFfyXBdJJosDRS: 0,
    DG2xFkPdDwKUoBkzGAhQtLpSGzfXLiCYPEzeKH2Ad24p: 0,
    '34N9YcEETLWn93qYQ64EsP1x89tSruJU44RrEMSXXEPJ': 0,
    '6XtHjpXbs9RRJP2Sr9GUyVqzACcby9TkThHXnjVC5CDJ': 0,
    GAzAEjApmjMYZKPzri2g2VUXNvTiQGF7KDYZFFsP3AEq: 0
  }

  usdtPrices: {[x: string]: number} = {
    WAVES: 0,
    HEB8Qaw9xrWpWs8tHsiATYGBWDBtP2S7kcPALrMu43AS: 0,
    C1iWsKGqLwjHUndiQ7iXpdmPum9PeCDFfyXBdJJosDRS: 0,
    DG2xFkPdDwKUoBkzGAhQtLpSGzfXLiCYPEzeKH2Ad24p: 0,
    '34N9YcEETLWn93qYQ64EsP1x89tSruJU44RrEMSXXEPJ': 0,
    '6XtHjpXbs9RRJP2Sr9GUyVqzACcby9TkThHXnjVC5CDJ': 0,
    GAzAEjApmjMYZKPzri2g2VUXNvTiQGF7KDYZFFsP3AEq: 0
  }

  constructor(initState?: any) {
    this.requestQueue = new RequestQueue();
    this.marketStore = new MarketStore(this);
    this.accountStore = new AccountStore(this, initState?.accountStore);
    this.walletStore = new WalletStore(this, this.accountStore);
    this.notificationStore = new NotificationStore(this);
    makeAutoObservable(this);

    const loadPrices = () => {
      axios.get<IAssetInfo>('https://wavescap.com/api/assets-info.php', {
            params: {
                assetIds: [
                    'WAVES',
                    'DG2xFkPdDwKUoBkzGAhQtLpSGzfXLiCYPEzeKH2Ad24p', // usdn
                    '6XtHjpXbs9RRJP2Sr9GUyVqzACcby9TkThHXnjVC5CDJ', // usdc
                    '34N9YcEETLWn93qYQ64EsP1x89tSruJU44RrEMSXXEPJ', // usdt
                    'HEB8Qaw9xrWpWs8tHsiATYGBWDBtP2S7kcPALrMu43AS', // Puzzle
                    'C1iWsKGqLwjHUndiQ7iXpdmPum9PeCDFfyXBdJJosDRS', // EGG
                    '9wc3LXNA4TEBsXyKtoLE9mrbDD7WMHXvXrCjZvabLAsi', // USDT PPT
                    'HGgabTqUS8WtVFUJzfmrTDMgEccJuZLBPhFgQFxvnsoW', // USDC PPT
                    'GAzAEjApmjMYZKPzri2g2VUXNvTiQGF7KDYZFFsP3AEq', // PETE
                ],
                attributes: ['id', 'data']
            }
        }).then((response) => {
            response.data.assets?.forEach((asset) => {
                // this.usdnPrices[asset.id] = asset.data['lastPrice_usd-n'] || 0;
                this.usdtPrices[asset.id] = asset.data['lastPrice_usd'] || 0;
            });
        });
    }

    runInAction(() => {
      loadPrices();
    });

    this.requestQueue.addToEternal(() => {
      loadPrices();
    });

    // setInterval(() => {this.walletStore = new WalletStore(this, this.accountStore)}, 1000)
  }

  serialize = (): ISerializedRootStore => ({
    accountStore: this.accountStore.serialize(),
  });
}
